import { render, staticRenderFns } from "./compQuery.vue?vue&type=template&id=f87e9642&scoped=true&"
import script from "./compQuery.vue?vue&type=script&setup=true&lang=js&"
export * from "./compQuery.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./compQuery.vue?vue&type=style&index=0&id=f87e9642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87e9642",
  null
  
)

export default component.exports